import { Box } from '../../../components/UI-CHAKRA/Box';
import { Button } from '../../../components/UI-CHAKRA/Button';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { ReactComponent as PrescriptionIcon } from '../../../assets/images/icons/mevo/ic-my-prescription.svg';

interface DialogDuplicatedPrescriptionProps {
  onCancelPrevious: () => void;
  onChangeDate: () => void;
}

export const DialogDuplicatedPrescription = (props: DialogDuplicatedPrescriptionProps) => {
  const { onCancelPrevious, onChangeDate } = props;

  return (
    <Flex height="auto" w={'100%'} flexDirection={'column'} gap={'20px'}>
      <Flex gap={'10px'}>
        <PrescriptionIcon />
        <Box>
          <Text fontSize="14px" color={'error.main'} lineHeight={'16px'}>
            Aviso importante
          </Text>
          <Text fontSize="18px" fontWeight={700} lineHeight={'18px'}>
            Receita duplicada
          </Text>
        </Box>
      </Flex>

      <Box>
        <Text fontSize="14px">
          Você enviou uma receita com o <b>mesmo conteúdo</b> para este paciente.
        </Text>
        <Text fontSize="14px">
          Caso tenha cometido um erro na prescrição anterior e deseje corrigi-lo, podemos ajudar no cancelamento da
          receita anterior.
        </Text>
        <Text fontSize="14px" mt={'15px'}>
          Se a receita é planejada para <b>utilização futura nos próximos meses</b>, por favor,{' '}
          <Text as={'span'} fontWeight={'bold'} textDecor={'underline'}>
            altere a data da receita
          </Text>{' '}
          para refletir o plano de tratamento.
        </Text>
      </Box>
      <Flex gap={'10px'}>
        <Button
          variant={'outline'}
          borderColor={'error.main'}
          color={'error.main'}
          borderRadius={'30px'}
          onClick={onCancelPrevious}
        >
          Cancelar receita anterior
        </Button>
        <Button borderRadius={'30px'} onClick={onChangeDate}>
          Entendi, vou alterar a data
        </Button>
      </Flex>
    </Flex>
  );
};
